<template>
  <div class="tblOneComp">

    <div class="div_tbl">
      <table class="tbl_1">
        <tr v-for="(row, index) in rows" :key="index">
          <td>{{row.title}}</td>
          <td>{{cellHandler(row.value, rows, row.type, row.handler)}}</td>
        </tr>
      </table>
    </div>

  </div>
</template>

<script>
export default {
  name: 'tblOneComp',
  props: {
    rows: Object
  },
  data: function () {
    return {
    }
  },
  created: function () {
  },
  components: {
  },
  computed: {
  },
  methods: {
    cellHandler (value, data, type, handler) {
      return this.$helpers.table.cellHandler(value, data, type, handler)
    }
  }
}
</script>

<style scoped lang="scss">

.div_tbl {
  margin: 32px 32px 0 32px;
  overflow: auto;
  width: auto;
}
.div_tbl::-webkit-scrollbar {
    width: 10px;
}
.div_tbl::-webkit-scrollbar-track {
    border: 1px solid #bababa;
}
.div_tbl::-webkit-scrollbar-thumb {
    background: #ff8200;
}

.tbl_1 {
  border: 2px solid #bababa;
  border-radius: 9px 9px 9px 9px;
  -moz-border-radius: 9px 9px 9px 9px;
  -webkit-border-radius: 9px 9px 9px 9px;
  border-spacing: 0;
  width: 100%;
  margin-bottom: 20px;
}
.tbl_1 td:first-child {
  border-left: none;
  object-fit: contain;
  font-size: 16px;
  font-weight: 600;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: -0.4px;
  color: #ff8200;
}
.tbl_1 tr:first-child td{
  border-top: none;
}
.tbl_1 td{
  border-left: 2px solid #bababa;
  border-top: 2px solid #bababa;
  padding: 16px 24px 16px 24px;
  object-fit: contain;
  font-size: 16px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: -0.4px;
  text-align: center;
  color: #202020;
}

@media screen and (max-width: 1140px){
}
@media screen and (max-width: 960px){
}
@media screen and (max-width: 720px){
  .toolbar .search {
    width: 171px;
  }
  .toolbar select {
    margin-right: 10px;
  }
}
@media screen and (max-width: 540px){
}
@media screen and (max-width: 480px){
}
@media screen and (max-width: 320px){
}
</style>
